import moment from "moment";

//Sanitize table key
export const createKey = (input) => {
  return input ? input.replace(/^(the|a|an)/, "").replace(/\s/g, "") : input;
};
export const camelToTitle = (camelCase) => {
  return camelCase
    .replace(/([A-Z])/g, (match) => ` ${match}`)
    .replace(/^./, (match) => match.toUpperCase())
    .trim();
};

//Error Handler
export const errorHandler = (error) => {
  const { request, response } = error;
  if (response) {
    const status = response.status;
    const message = `Request failed with status code ${status}`;
    return {
      message,
      status,
    };
  } else if (request) {
    //request sent but no response received
    return {
      message: "server time out",
      status: 503,
    };
  } else {
    // Something happened in setting up the request that triggered an Error
    return { message: "Something went wrong while setting up request" };
  }
};

export const isNotUndefinedOrNull = (value) =>
  value !== null && value !== undefined;

export const isUndefinedOrNull = (value) =>
  value === null || value === undefined;

export const areAnyUndefinedOrNull = (...values) =>
  values.some(isUndefinedOrNull);

export const areAllDefinedAndNotNull = (...values) =>
  values.every((value) => value !== undefined && value !== null);

export const createDownloadFileName = (name) => {
  const fileName =
    `Revyz_${name}_` +
    moment().utc().format("MM-DD-YYYY") +
    "-" +
    moment().utc().get("hour") +
    "-" +
    moment().utc().get("minute") +
    "-" +
    moment().utc().get("second");
  return fileName;
};
